import { cn } from '@/lib/utils';

// Shared by the platform Sidebar and CmsSidebar, which renders inside it, so
// every nav item in the rail looks and behaves the same.
//
// All colours come from CSS custom-property tokens (--sidebar-*, --primary, etc.)
// so the sidebar adapts to light / dark / brand / hc themes and to the accent
// colour picker automatically. The only hardcoded palette classes are for the
// high-contrast (hc) override.

/** Default (resting) nav item */
export const NAV_DEFAULT = [
  'text-sidebar-foreground',
  'hover:text-sidebar-accent-foreground hover:bg-sidebar-accent',
  'transition-colors duration-150',
  'focus-visible:outline-none focus-visible:ring-2',
  'focus-visible:ring-sidebar-border focus-visible:ring-offset-2 focus-visible:ring-offset-sidebar',
  'hc:text-white hc:hover:bg-white/10',
].join(' ');

/** Active nav item — brand-accent left border + tinted background */
export const NAV_ACTIVE = [
  'bg-sidebar-accent text-sidebar-accent-foreground font-semibold',
  'border-l-[3px] border-primary',
  'transition-colors duration-150',
  'focus-visible:outline-none focus-visible:ring-2',
  'focus-visible:ring-sidebar-border focus-visible:ring-offset-2 focus-visible:ring-offset-sidebar',
  'hc:bg-white hc:text-black hc:border-black',
].join(' ');

/** Collapsed icon button — default */
export const ICON_DEFAULT = [
  'flex h-10 w-10 items-center justify-center rounded-md',
  'text-sidebar-foreground',
  'hover:text-sidebar-accent-foreground hover:bg-sidebar-accent',
  'transition-colors duration-150',
  'focus-visible:outline-none focus-visible:ring-2',
  'focus-visible:ring-sidebar-border focus-visible:ring-offset-2 focus-visible:ring-offset-sidebar',
  'hc:text-white hc:hover:bg-white/10',
].join(' ');

/** Collapsed icon button — active */
export const ICON_ACTIVE = [
  'flex h-10 w-10 items-center justify-center rounded-md',
  'bg-sidebar-accent text-sidebar-accent-foreground',
  'transition-colors duration-150',
  'focus-visible:outline-none focus-visible:ring-2',
  'focus-visible:ring-sidebar-border focus-visible:ring-offset-2 focus-visible:ring-offset-sidebar',
  'hc:bg-white hc:text-black',
].join(' ');

/** Section row (Home, Incident Management, CMS…). */
export const NAV_ROW = 'flex w-full min-w-0 items-center gap-3 rounded-md px-3 py-2.5 text-left text-[15px] font-medium leading-5';

/** Link inside an expanded section. */
export const NAV_SUB_ROW = 'flex min-w-0 items-center gap-3 rounded-md px-3 py-2 text-[15px] font-medium leading-5';

/**
 * Indent for a section's links: 28px lines each sub-item's icon up under the
 * parent's label (3px border + 12px padding + 16px icon + 12px gap = 43px).
 */
export const NAV_SUB_LIST = 'flex flex-col gap-y-1.5 pl-7 pb-1';

/** Resting items reserve the active border's 3px so labels do not shift. */
export function navItemState(active: boolean): string {
  return active ? NAV_ACTIVE : cn(NAV_DEFAULT, 'border-l-[3px] border-transparent');
}
